import Instance from "../../../Axios";

const GetPlusTipoDocsAdesao = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/tipoDocsAdesao`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_TIPO_DOCS_ADESAO", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusTipoDocsAdesao;
